

 $(document).ready(function() {

  var dirRtlFlag = false;

if ($("html").attr('dir') == 'rtl') {

 dirRtlFlag = true;

}





    $('.products-slider').slick({

      dots: false,

      arrows: true,

      infinite: true,

      speed: 1000,

      autoplay: true,

      autoplaySpeed: 1000,

      rtl: dirRtlFlag,

      slidesToShow: 4,

      prevArrow: $('.products-slider__prev'),

      nextArrow: $('.products-slider__next'),

      centerMode: false,

      responsive: [

        {

          breakpoint: 1350,

          settings: {

          slidesToShow: 3,

          slidesToScroll: 1

          }

        },

        {

          breakpoint: 980,

          settings: {

          slidesToShow: 2,

          slidesToScroll: 1,

          centerMode: false,

          }

        },

        {

          breakpoint: 490,

          settings: {

          slidesToShow: 1,

          slidesToScroll: 1,

          centerMode: false,

          }

        },

        // You can unslick at a given breakpoint now by adding:

        // settings: "unslick"

        // instead of a settings object

        ] 

      });





      $('.products-slider-2').slick({

        dots: false,

        arrows: true,

        infinite: true,

        speed: 1000,

        autoplay: true,

        autoplaySpeed: 1000,

        rtl: dirRtlFlag,

        slidesToShow: 4,

        prevArrow: $('.products-slider-2__prev'),

        nextArrow: $('.products-slider-2__next'),

        centerMode: false,

        responsive: [

          {

            breakpoint: 1350,

            settings: {

            slidesToShow: 3,

            slidesToScroll: 1

            }

          },

          {

            breakpoint: 980,

            settings: {

            slidesToShow: 2,

            slidesToScroll: 1,

            centerMode: false,

            }

          },

          {

            breakpoint: 490,

            settings: {

            slidesToShow: 1,

            slidesToScroll: 1,

            centerMode: false,

            }

          },

          // You can unslick at a given breakpoint now by adding:

          // settings: "unslick"

          // instead of a settings object

          ] 

        });





        $('.products-slider-3').slick({

          dots: false,

          arrows: true,

          infinite: true,

          speed: 1000,

          autoplay: true,

          autoplaySpeed: 1000,

          rtl: dirRtlFlag,

          slidesToShow: 4,

          prevArrow: $('.products-slider-3__prev'),

          nextArrow: $('.products-slider-3__next'),

          centerMode: false,

          responsive: [

            {

              breakpoint: 1350,

              settings: {

              slidesToShow: 3,

              slidesToScroll: 1

              }

            },

            {

              breakpoint: 980,

              settings: {

              slidesToShow: 2,

              slidesToScroll: 1,

              centerMode: false,

              }

            },

            {

              breakpoint: 490,

              settings: {

              slidesToShow: 1,

              slidesToScroll: 1,

              centerMode: false,

              }

            },

            // You can unslick at a given breakpoint now by adding:

            // settings: "unslick"

            // instead of a settings object

            ] 

          });



      $('#hp-teams').slick({

        dots: false,

        infinite: true,

        speed: 2000,

        slidesToShow: 3,

        slidesToScroll: 1,

        arrows: false,

        autoplay: true,

        autoplaySpeed: 3000,

        rtl: dirRtlFlag,

        centerMode: true,

        centerPadding: '12%',

        responsive: [{

            breakpoint: 1650,

            settings: {

              centerPadding: '10%',

            }

          }, {

            breakpoint: 1400,

            settings: {

              centerPadding: '10%',

              slidesToShow: 2,

            }

          }, {

            breakpoint: 1250,

            settings: {

              centerPadding: '5%',

              slidesToShow: 2,

            }

          },

          {

            breakpoint: 993,

            settings: {

              centerPadding: '0%',

              slidesToShow: 2,

              centerMode: false,

            }

          },

          {

            breakpoint: 820,

            settings: {

              slidesToShow: 1,

              slidesToScroll: 1,

              centerPadding: '0%',

              centerMode: false,

            }

          },

          {

            breakpoint: 550,

            settings: {

              slidesToShow: 1,

              slidesToScroll: 1,

              centerPadding: '0%',

              centerMode: false,

            }

          }

        ]

      });

    

      $('.prev-team').click(function() {

        $('#hp-teams').slick('slickPrev');

        return false;

      });

    

      $('.next-team').click(function() {

        $('#hp-teams').slick('slickNext');

        return false;

      });





      $('.cat-slider-sec').slick({

        dots: false,

        arrows: true,

        infinite: true,

        speed: 1000,

        autoplay: true,

        autoplaySpeed: 1000,

        rtl: dirRtlFlag,

        slidesToShow: 4,

        prevArrow: $('.cat-slider-sec__prev'),

        nextArrow: $('.cat-slider-sec__next'),

        centerMode: false,

        responsive: [

          {

            breakpoint: 1350,

            settings: {

            slidesToShow: 3,

            slidesToScroll: 1

            }

          },

          {

            breakpoint: 980,

            settings: {

            slidesToShow: 2,

            slidesToScroll: 1,

            centerMode: false,

            }

          },

          {

            breakpoint: 490,

            settings: {

            slidesToShow: 1,

            slidesToScroll: 1,

            centerMode: false,

            }

          },

          // You can unslick at a given breakpoint now by adding:

          // settings: "unslick"

          // instead of a settings object

          ] 

        });



     





})



